var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingRightLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 674,
    viewBox: "0 0 201 674",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.394 306.758C50.4889 331.335 0.843496 403.396 1.92706 488.108C3.23955 590.894 80.2946 674.035 173.16 672.988C265.98 671.958 340.945 588.36 340.945 485.371C340.945 439.78 327.759 396.521 301.814 365.474C232.497 282.484 9.25253 50.003 9.25253 50.003C-7.32139 32.1315 4.10942 0.999991 27.261 0.99999L347.049 0.999974",
    stroke: "url(#paint0_linear_37_284)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_284",
    x1: 174,
    y1: 672.498,
    x2: 174,
    y2: 1.25314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34C6F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingRightLines);
export default __webpack_public_path__ + "static/media/landingRightLines.cb93611d335db3f065969758981a10a9.svg";
export { ForwardRef as ReactComponent };